/**
 * @Author: ikoros
 * @Date:   2020-04-06T18:42:06+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-04-06T18:42:19+08:00
 */

import React, {useState, lazy, Suspense} from 'react';

import Context from './../context';

import Router from './../router';

import Header from './../component/basic-header';
import Menu from './../component/basic-menu';
import Elevator from './../component/basic-elevator';
import Footer from './../component/basic-footer';
import LoginModal from './../component/basic-login';
import ArticleModal from './../component/basic-article';
import BasicPiaochuang from './../component/basic-piaochuang';

import {BrowserRouter} from 'react-router-dom'

import * as session from './../utils/session';

import * as Api from './../api';
const baseKaptchaURL = Api.baseUrl +'kaptcha';
let defaultKaptchaURL =  baseKaptchaURL +'?v='+ Math.random();

export default () => {
    const [isLoginModalVisiable, setLoginModalVisiable] = useState(false);
    const [isGotoPublish, setGotoPublishModalVisiable] = useState(false);
    const [isArticleModalVisiable, setArticleModalVisiable] = useState(false);
    const [username, setUsername] = useState(((session.get() || {}).account || {}).loginName || "");
    const [category, setCategory] = useState([]);
    const [menu, setMenu] = useState([]);
    const [refresh, setRefresh] = useState(Date.now());

    return (
        <Context.Provider value={[]}>
            <BrowserRouter>
            <div className="root-section">
                <div className="root-wrapper default-theme">
                    <Header refreshKaptcha = {()=>{
                        defaultKaptchaURL =  baseKaptchaURL +'?v='+ new Date().getTime();
                    }}
                     setLoginModalVisiable={(visiable, isGotoState) => {
                        setLoginModalVisiable(visiable);
                        setGotoPublishModalVisiable(isGotoState);
                    }} username={username} logout={() => {
                        setUsername("");
                        setLoginModalVisiable(false);
                        setGotoPublishModalVisiable(false);
                        setArticleModalVisiable(false);
                        setRefresh(Date.now());
                    }}></Header>
                    <Menu onPublish={(category) => {
                        setCategory(category);

                        if(((session.get() || {}).account || {}).loginName) {
                            setGotoPublishModalVisiable(true);
                            setArticleModalVisiable(true);

                        } else {
                            setLoginModalVisiable(true);
                        }
                        
                    }} onLoadMenu={(data) => {
                        setMenu(data);
                    }}></Menu>
                    <Router menu={menu} refresh={refresh}></Router>
                    {/* <Elevator></Elevator> */}
                    <Footer></Footer>
                </div>
                {
                    isLoginModalVisiable ? <LoginModal defaultKaptchaURL={defaultKaptchaURL} setLoginModalVisiable={(visiable) => {
                        setLoginModalVisiable(visiable);
                    }} setAccount={(data)=> {
                        session.set(data);
                        setRefresh(Date.now());
                        setUsername(data.account.realName);
                        setArticleModalVisiable(true);
                    }}></LoginModal> : ""
                }

                {isArticleModalVisiable && isGotoPublish ? <ArticleModal category={category} setArticleModalVisiable ={(visiable) => {
                    setArticleModalVisiable(visiable);
                }}></ArticleModal> : ""}
                <BasicPiaochuang/>
            </div>
            </BrowserRouter>
        </Context.Provider>
    );
}
